import { Box, BoxProps } from "@mui/system";
import { forwardRef } from "react";

/** Box that can change the type of display */
export default forwardRef((props: BoxProps, ref) => {
	return <Box ref={ref} {...props} />;
});
